import './Loader.scoped.scss';

const Loader = ({ size = 15 }) => {
  return <div style={{ width: `${size}px`, height: `${size}px` }}></div>;
};

export default Loader;
